import React from 'react';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from "react-google-maps";
import { compose, withProps } from "recompose";

const ReactMarkdown = require('react-markdown');

const DPCGoogleMap = compose(
  withProps({
    googleMapURL:
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyAmqw3-zqEwtZ0mn-31nMkMOzBfvo1xfxM&v=3.exp&libraries=geometry,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `100%` }} />,
    mapElement: <div style={{ height: `100%` }} />
  }),
  withScriptjs,
  withGoogleMap
)(props => (
  <GoogleMap defaultZoom={14} defaultCenter={{ lat: props.lat, lng: props.lng }}>
    <Marker position={{ lat: props.lat, lng: props.lng }} />
  </GoogleMap>
));

class ChurchLocation extends React.Component{

    ref = React.createRef();

    state = {
      mapWidth: 0
    }

    componentDidMount(){
      this.setState({
        mapWidth: this.ref.current.clientWidth
      }, () => console.log(this.state.mapWidth))
    }

    render(){
        console.log(this.props.fields.mapLocation)
        return (
            <div className="row church-location">
                <div className="col-12 church-location-title" style={{color: this.props.primeColor}}> {this.props.fields.sectionTitle}
                    <div className="row church-location-content">
                        <div className="col-3 offset-3 church-location-left">
                            <h2> {this.props.fields.churchName} </h2>
                            <h3> {this.props.fields.shortDescription} </h3>
                            <h4> {this.props.fields.churchAddress} </h4>
                            <ReactMarkdown escapeHtml={false} source={this.props.fields.serviceTimes}/>
                        </div>
                        <div className="col-3 church-location-right">
                            <div className="church-location-map" ref={this.ref} style={{height:this.state.mapWidth+"px"}}>
                                <DPCGoogleMap
                                    lat={this.props.fields.mapLocation.lat}
                                    lng={this.props.fields.mapLocation.lon}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ChurchLocation;
